import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import HorizontalForm from './components/MISPOToGRNReport';
/*import Table from '../../Tables/DataTable/components/DataTable';*/
/*import VerticalForm from './components/masterForm';*/
/*import showResults from '../Show';*/

const MISPOToGRNReport = ({ t }) => (
  <Container>
    <Row>
      <Col md={12} style = {{marginBottom : "-15px"}}>
        <h3 className="page-title">REPORTS - Purchase </h3>
      </Col>
    </Row>
       
    <Row>
      <HorizontalForm />
    </Row>

   
  </Container>
);

MISPOToGRNReport.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(MISPOToGRNReport);
